import events from '../constants/events';
import urls from '../constants/urls';
import { dispatchEvent } from './customEvents';
import { openDB } from "idb";

const { productCount = 1 } = window.mosmosh;
const collectionApiPaginationNumber = 50;
const requestNumber = Math.ceil(productCount / collectionApiPaginationNumber);

let productData = {};

async function storeData(data) {
  try {
    if (('indexedDB' in window) && !Shopify.designMode) {
      const dbPromise = await openDB(`mosmosh-${Shopify.country}-products`, 1, {
        upgrade(database) {
          if (!database.objectStoreNames.contains('products')) {
            const store = database.createObjectStore('products', { keyPath: 'product_id' })

            store.createIndex('product_id', 'product_id', { unique: true });
            store.createIndex('data', 'data', { unique: false });
          }
        }
      });

      const tx = dbPromise.transaction(['products'], 'readwrite');
      const productStore = tx.objectStore("products");

      const test = Object.keys(data).map(productId => {
        productStore.put({
          product_id: productId,
          data: data[productId]
        })
      })

      await Promise.all([
        ...test,
        tx.done
      ]);
    } else {
      // This browser doesn't support IndexedDB
      localStorage.setItem('mm_products', JSON.stringify(data))
    }

    // Update tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem('db_next_update', tomorrow.getTime().toString())

    window.mosmosh.productData = data;
    window.mosmosh.productDataLoaded = true;
    dispatchEvent(window, events.PRODUCT_DATA_LOADED);
  } catch (e) {
    try {
      localStorage.setItem('mm_products', JSON.stringify(data));

      // Update tomorrow
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      localStorage.setItem('db_next_update', tomorrow.getTime().toString())

      window.mosmosh.productData = data;
      window.mosmosh.productDataLoaded = true;
      dispatchEvent(window, events.PRODUCT_DATA_LOADED);
    } catch (e) {
      console.error(e);
    }
  }
}

async function updateData() {
  const fetches = [];
  for (let i = 1; i <= requestNumber; i++) {
    fetches.push(fetch(`${urls.COLLECTION_API}?page=${i}`))
  }

  const responses = await Promise.all(fetches);
  const data = await Promise.all(responses.map(res => res.json()));
  data.forEach(arr => {
    productData = Object.assign(productData, arr)
  })

  storeData(productData);
}

export const cacheProductData = async () => {
  if (Shopify.designMode) return;

  const nextUpdate = localStorage.getItem('db_next_update');
  if (!nextUpdate || nextUpdate && new Date().getTime() > parseInt(nextUpdate)) {
    updateData()
  } else {
    try {
      if (!localStorage.getItem('mm_products')) {
        const db = await openDB(`mosmosh-${Shopify.country}-products`, 1);

        if (!db.objectStoreNames.contains('products')) {
          updateData();
          return;
        }

        const allValues = await db.getAll('products');
        allValues.forEach(item => {
          const tmp = {};

          tmp[item.product_id] = item.data
          productData = Object.assign(productData, tmp)
        })
      }

      window.mosmosh.productData = localStorage.getItem('mm_products') ? JSON.parse(localStorage.getItem('mm_products')) : productData;
      window.mosmosh.productDataLoaded = true;
      dispatchEvent(window, events.PRODUCT_DATA_LOADED);
    } catch (e) {
      console.error(e)
    }
  }
};
